module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAAAXNSR0IArs4c6QAAASJJREFUaEPtlcEKgkAURR0bBXe1ihYK1i/4/1/gL5Sgi2hVO0EnJ1oEEemDt7oO163z4Nx7HjMmCvwzgeeLGHDthmmQBsEb4IqCCxLxaFCsCPwADYILEvFoUKwI/AANggsS8WhQrAj8AA2CCxLxaFCsCPwADXrvTVVVtu97qDKyLPN1XTtjjF9aokXosiz3wzAcpmnaIG5iHMfPNE2vTdPc5vhmAxZFsRvH8YgY7JcpSZJL27b3f6yzAfM8PznntmsIaK19dF13ZsDvBoJf0XfYoC+Zj82gn4k1XDASI9TjLcFq/jOgpjWkGRpEsqFhoUFNa0gzNIhkQ8NCg5rWkGZoEMmGhoUGNa0hzdAgkg0NCw1qWkOaoUEkGxoWGtS0hjTzAswvUDk41VWCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mall/minus.png
// module id = hdrd
// module chunks = 216